import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/ui/Reveal';
import { SectionLabel } from '../components/ui/SectionLabel';
import { SplitText } from '../components/ui/SplitText';
import { CtaBanner } from '../components/CtaBanner';
import { sectors } from '../data/sectors';
import { images } from '../data/images';
export function Sectors() {
  return <>
      <PageHero label="Secteurs" title="Chaque secteur a ses contraintes. Je les connais." description="Industrie, distribution, agroalimentaire, services, secteur public : les leviers achats et supply chain ne sont pas les mêmes partout. Voici ceux que j’active selon votre activité." image={images.port} data-id="element-676" data-mp="dzouvui5katw" />

      <section className="bg-paper py-24 lg:py-32" data-id="element-677" data-mp="su3cbqm2jc6g">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-678" data-mp="2ppho6errjdvr">
          <div className="max-w-3xl" data-id="element-679" data-mp="2unj78zp6vd78">
            <SectionLabel data-id="element-680" data-mp="2uokfyxiqfnls">Secteurs accompagnés</SectionLabel>
            <h2 className="mt-6 text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-681" data-mp="31dv0ccl3zl7w">
              <SplitText text="Enjeux et leviers, secteur par secteur." data-id="element-682" data-mp="2wmmq5ebyfvto" />
            </h2>
          </div>

          <div className="mt-14 hidden grid-cols-12 gap-8 border-b border-ink/15 pb-4 text-sm text-muted md:grid" data-id="element-683" data-mp="2rniiis4oi65g">
            <span className="col-span-3" data-id="element-684" data-mp="2mq04wofpv2r4">Secteur</span>
            <span className="col-span-4" data-id="element-685" data-mp="3kcpfhmohinol">Enjeu principal</span>
            <span className="col-span-5" data-id="element-686" data-mp="3kc7bu4zht76n">Leviers activés</span>
          </div>
          <ul data-id="element-687" data-mp="3fenwt2uz0qdn">
            {sectors.map((s, i) => <li key={s.name} data-id="element-688" data-mp="3fbt992gnupg0" data-mpi={i}>
                <Reveal delay={0.03 * i} y={16} data-id="element-689" data-mp="3adrvmx207ibx">
                  <div className="grid gap-3 border-b border-ink/10 py-7 md:grid-cols-12 md:items-center md:gap-8" data-id="element-690" data-mp="3agmdcgtmup1n">
                    <h3 className="text-xl font-medium md:col-span-3" data-id="element-691" data-mp="1yze9pxqt9cyj">{s.name}</h3>
                    <p className="leading-relaxed text-muted md:col-span-4" data-id="element-692" data-mp="1yx9x8reuj5mn">{s.challenge}</p>
                    <ul className="flex flex-wrap gap-2 md:col-span-5" data-id="element-693" data-mp="1uzvpz5aq77xa">
                      {s.levers.map(l => <li key={l} className="rounded-md bg-white px-3 py-1.5 text-sm ring-1 ring-inset ring-ink/10" data-id="element-694" data-mp="21e19iqrolz4y">
                          {l}
                        </li>)}
                    </ul>
                  </div>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBanner data-id="element-695" data-mp="1dnot0rideu2r" />
    </>;
}